import { render } from "./presupuesto_baremo.vue?vue&type=template&id=b3d2db0a&scoped=true"
import script from "./presupuesto_baremo.vue?vue&type=script&lang=js"
export * from "./presupuesto_baremo.vue?vue&type=script&lang=js"

import "./presupuesto_baremo.vue?vue&type=style&index=0&id=b3d2db0a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d2db0a"]])

export default __exports__